import axios from '../../helpers/axios'
import {
  IResponse,
  IPeopleAgent,
  IPeople
} from '../../models';
import { logError } from '../../services';

const base = `/api/shared/lookup/people`;

export const getAgents = async (isActive?: boolean): Promise<IResponse<IPeople[]>> => {
  try {
    const { data } = await axios.get(`${base}`, {
      params: { personType: 'InternalAgent', isActive: isActive }
    });
    return data;
  } catch (error) {
    logError(
      {
        error
      },
      'getAgents failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getAgentsLookup = async (isActive?: boolean, existingAgentId?: number | null): Promise<IPeopleAgent[]> => {
  try {
    const { data } = await axios.get(`${base}/agents`, {
      params: {
        isActive: isActive,
        existingAgentId: existingAgentId,
       }
    });
    return data;
  } catch (error) {
    logError(
      {
        error
      },
      'getAgentsLookup failed'
    );
    return Promise.reject(error?.response?.data);
  }
};